export default {
    'DOWNLOAD': 'Antrag herunterladen',
    'Edit': 'Bearbeiten',
    'Delete': 'Löschen',
    'Save': 'Sichern',
    'Reset': 'Zurücksetzen',
    'Update': 'Aktualisieren',
    'Create': 'Anlegen',
    'Cancel': 'Abbrechen',
    'Menu': 'Menü',
    'Manage Menu': 'Menu verwalten',
    'ID': 'ID',
    'Icon': 'Symbol',
    'Remark': 'Anmerkung',
    'URL': 'URL',
    'Operations': 'Operationen',
    'Manage Roles': 'Rollen verwalten',
    'Date': 'Datum',
    'Permission': 'Genehmigung',
    'Add Role': 'Rolle hinzufügen',
    'Edit Role': 'Rolle bearbeiten',
    'Check all': 'Alle überprüfen',
    'Confirm': 'Bestätigen',
    'First Name': 'Vorname',
    'Last Name': 'Nachname',
    'Email': 'E-Mail',
    'Edit User': 'Benutzer bearbeiten',
    'Gender': 'Geschlecht',
    'Male': 'Männlich',
    'Female': 'Weiblich',
    'Email Address': 'E-Mail Adresse',
    'Manage Users': 'Benutzer verwalten',
    'Manage Permissions': 'Berechtigungen verwalten',
    'Edit Permission': 'Berechtigungen bearbeiten',
    'Display Name': 'Anzeigename',
    'General Settings': 'Allgemeine Einstellungen',
    'Admin Email': 'Admin E-Mail',
    'Timezone': 'Zeitzone',
    'Date Format': 'Datums Format',
    'Time Format': 'Zeitformat',
    'Logo Upload': 'Logo hochladen',
    'Create Menu': 'Menu anlegen',
    'Edit Menu': 'Menu bearbeiten',
    'Menu Title': 'Menutitel',
    'Menu Icon': 'Menu Symbol',
    'Select Parent': 'Haupttitel auswählen',
    'Category': 'Kategorie',
    'Menu status': 'Menustatus',
    'Order Number': 'Auftrag anzeigen',
    'Enable': 'Aktivieren',
    'Disable': 'Deaktivieren',
    'Modified at': 'geändert am',
    'Parent name': 'Hauptname',
    'Search': 'Suchen',
    'Use 24h clock': '24h Uhr benützen',
    'Use 12h clock': '12h Uhr benützen',
    'Select Timezone': 'Zeitzone auswählen',
    'Select DateFormat': 'Datumsformat auswählen',
    'Select TimeFormat': 'Zeitformat auswählen',
    'Select language': 'Sprache auswählen',
    'Select currency': 'Währung auswählen',
    'Please input valid email address': 'Bitte fügen Sie eine gültige E-Mail-Adresse ein',
    'Language': 'Sprache   ',
    'Currency': 'Währung   ',
    'Manage spenders': 'Spender verwalten',
    'Company name': 'Firmenname',
    'Address': 'Adresse',
    'Manage organizations': 'Regionen verwalten',
    'Website': 'Webseite',
    'Phone': 'Telefon',
    'Place': 'Ort',
    'Name': 'Name',
    'Create Organization': 'Region anlegen',
    'Confirm password': 'Passwort bestätigen',
    'password': 'Passwort',
    'Zipcode': 'Postleitzahl',
    'Create Spender': 'Spender anlegen',
    'Password and password confirmation both should be match': 'Passwort und Bestätigung müssen übereinstimmen',
    'Please enter valid zipcode': 'Bitte geben Sie eine gültige Postleitzahl ein.',
    'Please enter proper website URL': 'Bitte geben Sie die richtige Webseite ein.',
    'Edit Role Permission': 'Rollen Berechtigung bearbeiten',
    'Role': 'Rolle         ',
    'Permissions': 'Berechtigung',
    'Delete Role': 'Rolle löschen',
    'Parent Role': 'Eltern Rolle',
    'Created at': 'erstellt am',
    'Role name is required': 'Rollenname ist erforderlich',
    'Create Role': 'Rolle anlegen',
    'Role name': 'Rollenname   ',
    'Activity Logs': 'Aktivitätenprotokoll',
    'Manage clubs': 'Clubs verwalten',
    'Create Club': 'Club anlegen',
    'Select Organization': 'Region wählen',
    'Please select': 'Bitte wählen',
    'Organization': 'Regionen',
    'Organization_new': 'Region',
    'Start typing': 'Beginnen Sie zu tippen',
    'Changed By': 'Geändert von',
    'Changed Data': 'Geänderte Daten',
    'On Module': 'Auf Modul',
    'Action': 'Aktion',
    'Alphabetical filter': 'Alphabetischer Filter',
    'Success': 'Erfolg',
    'Error': 'Fehler',
    'Warning': 'Warnung',
    'OK': 'OK',
    'Spender': 'Spender',
    'This will permanently delete the': 'Dauerhaft gelöscht',
    'Do you want to continue?': 'Wollen Sie fortfahren?',
    'Image type must be of JPG or PNG format': 'Bildtyp muss JPEG oder PNG Format sein',
    'Image size should not exceed to 2MB': 'Bildgrösse sollte 2MB nicht überschreiten',
    'File size should not exceed to 2MB' : 'Dateigröße sollte 2 MB nicht überschreiten',
    'or upload an invoice with a payment slip.' : 'oder Rechnung mit Einzahlungsschein hochladen.',
    'Documents' : 'Dokumente',
    'Payment instructions:' : 'Zahlungsinstruktionen:',
    'Please enter the recipient\'s IBAN and account details': 'Bitte IBAN und Kontodetails des Empfängers erfassen',
    'Club': 'Club',
    'Select menu icon': 'Menu Icon auswählen',
    'Select parent menu': 'Hauptmenu auswählen',
    'Select category': 'Kategorie auswählen',
    'Clubs': 'Clubs',
    'Contacts': 'Kontakte',
    'My Profile': 'Mein Profil',
    'Profile Image': 'Profilbild',
    'Change Password': 'Passwort ändern',
    'Current Password': 'Aktuelles Passwort',
    'New Password': 'Neues Passwort',
    'Create club contact': 'Kontakt anlegen',
    'Can vote?': 'können Sie wählen?',
    'Manage club contacts': 'Kontakte verwalten',
    'Manage organization contacts': 'Kontakte verwalten',
    'Active': 'Aktiv',
    'Inactive': 'Inaktiv',
    'active': 'Aktiv',
    'inactive': 'Inaktiv',
    'Yes': 'Ja',
    'No': 'Nein',
    'Create organization contact': 'Kontakt anlegen',
    'Club details': 'Clubdetails',
    'Details': 'Details',
    'Update Spender': 'Spender aktualisieren',
    'Update Club': 'Club aktualisieren',
    'Update Organization': 'Region aktualisieren',
    'Update organization contact': 'Kontakt aktualisieren',
    'Manage Fachstellen': 'Fachstelle verwalten',
    'Update Fachstellen': 'Fachstelle aktualisieren',
    'Create Fachstellen': 'Fachstelle anlegen',
    'This field is required': 'Dieses Feld wird benötigt',
    'Update club contact': 'Kontakt aktualisieren',
    'DOB': 'Geburtsdatum',
    'Admission': 'Zugang',
    'Manage patenkinder': 'Patenkind verwalten',
    'Create patenkind': 'Patenkind anlegen',
    'Origin country': 'Herkunftsland',
    'Select country': 'Land auswählen',
    'Father name': 'Name des Vaters',
    'Mother name': 'Name der Mutter',
    'Other': 'Andere',
    'Primary mobile number': 'Erste Mobile Nummer',
    'Secondary mobile number': 'Zweite Mobile Nummer',
    'Update patenkind': 'Patenkind aktualisieren',
    'Manage Fachstellen Contacts': 'Kontakt verwalten',
    'Create Fachstellen Contacts': 'Kontakt anlegen',
    'Update Fachstellen Contacts': 'Kontakt aktualisieren',
    'Fachstellen Name': 'Name Fachstelle',
    'Description Of The Application': 'Beschreibung des Antrags',
    'Patenkinder Name': 'Name Patenkind',
    'Case': 'Anträge',
    'Manage Cases': 'Anträge verwalten',
    'Can Login?': 'Login?',
    'Case Title': 'Beschreibung Anträge',
    'Create Case': 'Antrag',
    'Please enter number': 'Bitte geben Sie eine Nummer ein',
    'Patenkinder': 'Patenkinder',
    'Age': 'Alter',
    'Patenkinder Details': 'Patenkind Details',
    'Leaving': 'Verlassen',
    'Years': 'Jahre',
    'Year': 'Jahr',
    'Month': 'Monat',
    'Login': 'Login ',
    'Fachstellen sign up': 'Fachstelle anmelden',
    'Signup': 'Anmelden',
    'Cases': 'Anträge',
    'Function': 'Funktion',
    'Case Details': 'Antrag',
    'Created on': 'erstellt am',
    'Title': 'Beschreibung',
    'Attachment': 'Anhang',
    'Reject case': 'Fall ablehnen',
    'Expected amount': 'Beantragte Kosten',
    'Status': 'Status',
    'Vote Details': 'Abstimmungsdetails',
    'Total voters': 'Anzahl stimmberechtigte',
    'Total voters1': 'Anzahl stimmberechtigte',
    'Agree': 'Einverstanden',
    'Not agree': 'Nicht einverstanden',
    'In discussion': 'offen',
    'Club member details': 'Clubmitglied Details',
    'Review Details': 'Details überprüfen',
    'Amount': 'Kosten',
    'Confirmed amount': 'genehmigte Kosten',
    'Approve and send email': 'Genehmigen und E-Mail senden',
    'Approve': 'Genehmigen',
    'Update request': 'Antrag aktualisieren',
    'Fachstellen': 'Fachstellen',
    'Approved cases': 'genehmigte Anträge',
    'Rejected cases': 'abgelehnte Anträge',
    'Invite': 'Einladen',
    'Invite fachstellen': 'Fachstellen einladen',
    'Send link': 'Link senden',
    'Description of the application': 'Anonymisierte Beschreibung des Antrages  (Antragdetails, Selbstbeteiligung, Nutzen für das Kind)',
    'Criteria for supporting the godchild': 'Kriterien für die Unterstützung des Patenkindes',
    'It can be ensured that the support lines benefit only the child.': 'Es kann sichergestellt werden, dass die Unterstützungsleistungen nur dem Kind zugute kommen.',
    'The payment is made via a specialist office or with a direct payment slip (eg bill music school).': 'Die Bezahlung erfolgt über eine Fachstelle oder mit einem Einzahlungsschein (z.B. Rechnung Musikschule).',
    'It is ensured that no other organization (public sector, insurance, etc.) would have to pay for the neediness?': 'Es ist sichergestellt, dass keine andere Institution (öffentliche Hand, Versicherung usw.) für die Leistung aufkommen muss?',
    'The support service promotes the integration of the child into its environment / society (eg supporting activities with other children).': 'Die Unterstützungsleistung fördert die Entwicklung des Kindes in seine Umgebung / Gesellschaft (z.B. die Unterstützung von Aktivitäten mit anderen Kindern).',
    'Support requested': 'Beantragte Unterstützung',
    'What': 'Was',
    'Cost': 'Kosten',
    'Invalid number format': 'Ungültiges Zahlenformat',
    'Categories': 'Kategorien',
    'Description': 'Situation des Kindes',
    'Description1': 'Beschreibung',
    'Reject and send email': 'Ablehnen und E-Mail senden',
    'Reject': 'Ablehnen',
    'Vote now': 'Antrag genehmigen',
    'Skip Voting': 'Abstimmung überspringen',
    'Go ahead': 'Antrag genehmigen',
    'Life situation': 'Situation',
    'Needy': 'bedürftig',
    'Special': 'behindert',
    'Legal representatives': 'Gesetzliche Vertreter',
    'Parent': 'Eltern',
    'Guardian': 'Erziehungsberechtigter',
    'Publication': 'Veröffentlichung',
    'YES, this data may be published anonymously on the KiPaKi homepage': 'JA, diese Daten können anonym auf der KiPaKi-Homepage veröffentlicht werden',
    'NO, no data may be published on the KiPaKi homepage': 'NEIN, auf der KiPaKi-Homepage dürfen keine Daten veröffentlicht werden',
    'Only the following data may be published': 'Nur die folgenden Daten dürfen veröffentlicht werden',
    'Admission criteria': 'Zulassungskriterien',
    'The godchild is younger than 17 years or has no income (from profession or teaching)': 'Das Patenkind ist jünger als 17 Jahre oder hat kein Einkommen (aus Beruf oder Lehre)',
    'Legal representatives relation': 'Beziehung der gesetzlichen Vertreter',
    'Application and supervision of sponsorship / support services are provided by the department?': 'Antrag und Überwachung der Patenschaft/Unterstützungsleistungen erfolgen über die Fachstelle?',
    'It is pursued with the godchild a longer-term goal. (Recurring Benefits)': 'Mit dem Patenkind wird ein längerfristiges Ziel verfolgt. (Wiederkehrende Vorteile)',
    'Hereby, the department confirms, in agreement with the legal representative, the correctness and release of this data in connection with the sponsorship.': 'Hiermit bestätigt die Fachstelle im Einvernehmen mit dem gesetzlichen Vertreter die Richtigkeit und Freigabe dieser Daten im Zusammenhang mit der Unterstützung.',
    'Confirmation': 'Bestätigung',
    'It can be ensured that the respective support lines exclusively benefit the child.': 'Es kann sichergestellt werden, dass die jeweiligen Unterstützungsleistungen ausschließlich dem Kind zugute kommen.',
    'There are/were no conflicts with authorities or public bodies.': 'Es bestehen/bestanden keine Konflikte mit Behörden oder öffentlichen Stellen.',
    'Patenkind': 'Patenkind',
    'Go to next stage': 'Gehe zur nächsten Stufe',
    'Reply': 'Antworten',
    // 'Voting note': 'Empfehlung Geschäftsstelle',
    'Voting note' : 'EMPFEHLUNG GESCHÄFTSSTELLE', 
    'Want to reply?': 'Möchten Sie antworten?',
    'What\'s on your mind?': 'Was haben Sie auf dem Herzen?',
    'Votes': 'Stimmen',
    'kipaki portal': 'KiPaKi Portal',
    'Select Fachstellen': 'Fachstelle auswählen',
    'Go for voting': 'Zur Abstimmung gehen',
    'Actions': 'Aktion',
    'You have messages': 'Sie haben {0} Nachrichten',
    'View all': 'Alle ansehen',
    'Message': 'Mitteilungen',
    'Notifications': 'Nachrichten',
    'Organization Details': 'Region Einzelheiten',
    'Showing out of records': 'Anzeigen {0} von {1} Datensätzen',
    'Publication Description': 'Publikationsbeschreibung',
    'Are you sure want to reject this case?': 'Möchten Sie diesen Anträge wirklich ablehnen?',
    'Amount donated!': 'Betrag gespendet!',
    'Case added for club voting successfully!': 'Anträge für Clubabstimmung erfolgreich hinzugefügt!',
    'Case rejected!': 'Anträge abgelehnt!',
    'About case': 'Antragsdetails',
    'Fachstellen name': 'Fachstelle Name',
    'Fachstellen type': 'Art der Fachstelle',
    'Discussion': 'Diskussion',
    'Add comment': 'Kommentar hinzufügen',
    'Fachstellen details': 'Fachstelle Details',
    'Export': 'Export',
    'Settings': 'Einstellungen',
    'Give Your Vote': 'Geben Sie Ihre Stimme',
    'Kipaki charity dashboard | version 1.0': 'Kipaki Charity Dashboard | Version 1.0',
    'Themes': 'Themen',
    'Club Name': 'Name Club',
    'Grid view': 'Rasteransicht',
    'List view': 'Listenansicht',
    'Logout': 'Ausloggen',
    'Login to your account': 'Melden Sie sich in Ihr Konto an',
    'Forgot password?': 'Passwort vergessen?',
    'Back to login': 'Zurück zum Login',
    'Reset Password': 'Passwort zurücksetzen',
    'Organizations': 'Regionen',
    'Drag': 'Ziehen',
    'Added Patenkinder / fachstellen / clubs': 'Patenkinder / fachstellen / clubs hinzugefügt',
    'Cases per Types': 'Anträge pro Typ',
    'Over All Cases': 'Gesamtübersicht Anträgen',
    'confirmed amount': 'Bestätigter Betrag',
    'fachstellen / clubs per Organisation': 'fachstellen / Vereine pro Region',
    'Cases / amount per Fachstellen': 'Anträge / Betrag pro Fachstellen',
    'Recent cases': 'Aktuelle Anträge',
    'Dashboard': 'Dashboard',
    'Stage 1': 'Offen',
    'Stage 2': 'Für die Abstimmung gesendet',
    'Stage 3': 'In prüfung',
    'Donated': 'Bestätigt',
    'Rejected ': 'Abgelehnt',
    'Fachstellen contact': 'Fachstellen kontaktieren',
    'Email Templates': 'E-Mail-Vorlagen',
    'Email Template': 'E-Mail-Vorlage',
    'Manage Email Templates': 'E-Mail-Vorlagen verwalten',
    'Create Email Template': 'E-Mail-Vorlage erstellen',
    'Mail Content': 'E-Mail-Inhalt',
    'Subject': 'Gegenstand',
    'Edit Email Template': 'E-Mail-Vorlage bearbeiten',
    'Preview': 'Vorschau',
    'Are you sure want to skip voting for this case?': 'Möchten Sie die Abstimmung für diesen Fall wirklich überspringen?',
    'There is no discussion started.': 'Es wurde keine Diskussion begonnen.',
    'Remove': 'Löschen',
    'Manage Groups': 'Gruppen verwalten',
    'Created By': 'Erstellt von',
    'Create Group': 'Gruppe erstellen',
    'Update Group': 'Gruppe aktualisieren',
    'Group': 'Gruppe',
    'Manage Classes': 'Klassen verwalten',
    'Class': 'Klasse',
    'Fachstellen Person Name': 'Name Antragssteller',
    'Why skip voting?': 'Begründung Überspringen der Abstimmung',
    'Skip vote description': 'Begründung Überspringen der Abstimmung',
    'Re-open': 'wiedereröffnen',
    'Are you sure want to re-open this case?': 'Sind Sie sicher, dass Sie diesen Antrag wiedereröffnen wollen?',
    'Select Group': 'Wähle eine Gruppe',
    'Select Class': 'Klasse wählen',
    'Spenders': 'Spender',
    'Once': 'einmal',
    'Yearly': 'jährlich',
    'Donation Period': 'Zeitraum Spende',
    'Fachstellen wise patenkinder': 'Anzahl patenkinder pro fachstelle',
    'Year wise patenkinder': 'Anzahl patenkinder',
    'Country wise patenkinder': 'Anzahl patenkinder pro land',
    'Donation': 'Spende',
    'Payment Date': 'Zahlungsdatum',
    'Letter Sent': 'Brief gesendet',
    'Letter Sent?': 'Brief gesendet?',
    'Spender Donation': 'Spenderspende',
    'Create Donation': 'Spenden erstellen',
    'Manage spender Donation': 'Spender Spenden verwalten',
    'Donation Amount': 'Spendenbetrag',
    'Update Donation': 'Spenden aktualisieren',
    'No.': 'Nr.',
    'Godchild': 'Patenkind',
    'Fachstelle': 'Fachstelle',
    'Account No.': 'Konto Nr.',
    'Manage Accounts': 'Konten verwalten',
    'Create Account': 'Benutzerkonto anlegen',
    'Update Account': 'Aktualisiere den Account',
    'Accounts': 'Konten',
    'Account': 'Konto',
    'Account Groups': 'Kontogruppen',
    'Account Classes': 'Kontoklassen',
    'Groups': 'Gruppen',
    'Classes': 'Klassen',
    'Create Class': 'Klasse erstellen',
    'Update Class': 'Klasse aktualisieren',
    'Booking Date': 'Buchungsdatum',
    'Currency code': 'Währungscode',
    'Document date': 'Belegdatum',
    'Please enter a number': 'Bitte gebe eine Nummer ein',
    'Debited from': 'Soll',
    'Credited to': 'Haben',
    'Select currency code': 'Wählen Sie den Währungscode',
    'Booking Amount': 'Buchungsbetrag',
    'Booking Text': 'Buchungstext',
    'Update Account Booking': 'Kontobuchung aktualisieren',
    'Create Account Booking': 'Konto erstellen',
    'My ': 'Meine Dateien',
    'Account no': 'Konto Nr.',
    'Account name': 'Konto Name',
    'Booking list': 'Buchungsliste',
    'To': 'zu',
    'Receipt No': 'Beleg',
    'Credit': 'Haben',
    'Debit': 'Soll',
    'Total': 'Total',
    'Account Bookings': 'Kontobuchungen',
    'Group No.': 'Gruppen Nr.',
    'Class No.': 'Klassen Nr.',
    'Of': 'von',
    'Balance': 'Balance',
    'Previous year': 'Vorjahr',
    'To account': 'Gegenkonto',
    'Booking Text': 'Buchungstext',
    'Add to list': 'Einfügen',
    'Currency rate': 'Währungskurs',
    'Close': 'Schliessen',
    'General Account Settings': 'Allgemeine Konto Einstellungen',
    'Account Settings': 'Konto Einstellungen',
    'Area document no.': 'Bereich Dokumenten Nr.',
    'Start date': 'Startdatum',
    'End date': 'Enddatum',
    'Close booking year': 'Buchungsjahr schliessen',
    'Reset booking year': 'Buchungsjahr zurücksetzen',
    'Manage closed booking year': 'abgeschlossenes Buchungsjahr verwalten',
    'Zero balance accounts': 'Null Balance anzeigen',
    'Filter': 'Filter',
    'Class Type': 'Kontotyp',
    'Aktive': 'Aktive',
    'Passiv': 'Passiv',
    'Ertrag': 'Ertrag',
    'Aufwand': 'Aufwand',
    'Update list': 'Aktualisierungsliste',
    'Company': 'Firma',
    'Individual': 'individuell',
    'Type': 'Typ',
    'Select type': 'Typ wählen',
    'Confirmed amount and its description': 'Bestätigter Betrag und Beschreibung',
    'Comments': 'Bemerkungen',
    'Click on member image to see his/her remarks': 'Klicken Sie auf das Mitgliederbild, um seine Anmerkungen anzuzeigen',
    'Please first create a Fachstellen': 'Bitte erstelle eine Fachstelle',
    'Approval Mail': 'Bestätigt',
    'Please first create a Patenkinder': 'Bitte erstelle einen Patenkinder',
    'Access Users': 'Zugriff auf Benutzer',
    'Recent Activities': 'Kürzliche Aktivitäten',
    '0 to 5 Age': 'Alter von 0 bis 5 Jahren',
    '6 to 10 Age': 'Alter von 6 bis 10 Jahren',
    '11 to 18 Age': 'Alter von 11 bis 18 Jahren',
    'Above 18': 'Über 18',
    'Income statement from': 'Erfolgsrechnung vom',
    'to': 'bis',
    'Currency': 'Währung',
    'Expenditure': 'Ausgaben',
    'Earnings': 'Verdienste',
    'Income statement-total debit/credit': 'Erfolgsrechnung-Summe Soll/Haben',
    'Profit': 'Gewinn',
    'Balance per': 'Bilanz per',
    'Active': 'Aktiv',
    'Passive': 'Passiv',
    'Balance sheet total debit / credit': 'Bilanz-Summe Soll/Haben',
    'Yearly Report': 'Jahresbericht',
    'Daily Report': 'Tagesbericht',
    'Past Cases': 'Vergangene Anträge',
    'Confirmed Cases': 'Bestätigte Anträge',
    'Tag': 'Etikett',
    'Select Case': 'Fall auswählen',
    'No activity found.': 'Keine Aktivität gefunden',
    'Income Statement': 'Erfolgsrechnung',
    'Add Remark': 'Bemerkung hinzufügen',
    'Skip': 'Überspringen',
    'Note:': 'Hinweis:',
    'Voters': 'Stimmberechtigte',
    'To Fachstellen': 'zur Fachstelle',
    'Receipt number': 'Belegnummer',
    'File manager': 'Dateiverwaltung',
    'Manage Folders': 'Ordner verwalten',
    'Create Folder': 'Ordner erstellen',
    'Folder ID': 'Ordner ID',
    'Select Contacts': 'Kontakte auswählen',
    'Update folder': 'Ordner aktualisieren',
    'Folder': 'Ordner',
    'Show Role': 'Rolle zeigen',
    'Click the "Cases" Tab to Manage Cases': 'Klicken Sie auf "Anträge", um Anträge zu bearbeiten',
    'Click "+" to add new Case': 'Klicken Sie "+" um einen neuen Antrag anzulegen',
    'Choose a Godchild or press "Next" to Add God Child from the Godchild tab, if its not added': 'Wählen Sie ein Patenkind oder klicken Sie auf "Nächste", um ein Patenkind hinzuzufügen, wenn keines ausgewählt ist.',
    'Click the tab to Manage GodChild': 'Klicken Sie auf das Feld, um das Patenkind zu bearbeiten',
    'Click "+" to add new Godchild': 'Klicken Sie "+" um ein neues Patenkind anzulegen',
    'Click icon to give your vote': 'Klicken Sie auf das Symbol, um abzustimmen',
    'Click any icon to give your vote': 'Klicken Sie auf ein Symbol, um abzustimmen',
    'Add remarks here if you want': 'Geben Sie Ihre Bemerkung hier ein',
    'Press "Add Remarks" to Add Remarks <br /> Press "Skip" if you don\'t want to add voting remarks': 'Drücken Sie "Bemerkung hinzufügen" um eine Bemerkung hinzuzufügen <br /> Drücken Sie "überspringen" wenn Sie keine Bemerkung hinzufügen möchten',
    'Click on your image to see your remarks, if you have added': 'Klicken Sie auf Ihr Bild um Ihre Bemerkungen zu sehen, sofern Sie welche hinzugefügt haben',
    'Enter Comment and press "Add Comment" button': 'Geben Sie die Bemerkung ein und drücken Sie "Bemerkung hinzufügen"',
    'Comment added is shown here': 'Die hinzugefügte Bemerkung wird hier angezeigt',
    'Click "Reply" to reply over a comment': 'Klicken Sie auf "antworten", um auf eine Bemerkung zu antworten',
    'Enter reply message and press "Post" Button': 'Geben Sie die Antwortnachricht ein und drücken Sie das Feld "posten"',
    'Your reply will be shown here': 'Ihre Antwortnachricht wird hier angezeigt',
    'Click "Social Unit" to Manage Social Unit': 'Klicken Sie "Fachstelle", um die Fachstelle zu bearbeiten',
    'By clicking on "+" user can add new "Social Unit", <br> where user has to fill form of the Social Unit': 'Wenn Sie auf "+" klicken, können Sie eine neue Fachstelle erstellen,  <br> hier geben Sie die Daten der Fachstelle ein',
    'Fill Data to create Social Unit': 'Füllen Sie die fehlenden Felder aus, damit die Fachstelle erstellt wird',
    'Click "Godchild" to Manage Godchild': 'Klicken Sie auf "Patenkind" um das Patenkind zu verwalten',
    'By clicking on "+" user can add new "Godchild", <br> where user has to fill form of the Godchild': 'Wenn Sie auf "+" klicken, können Sie ein neues "Patenkind" hinzufügen,  <br> hier geben Sie die Daten des Patenkindes ein',
    'Fill Data to create Godchild': 'Füllen Sie die fehlenden Felder aus, damit das Patenkind erfasst wird',
    'Click "cases" to Manage cases': 'Klicken Sie auf "Anträge", um die Anträge zu bearbeiten',
    'By clicking on "+" user can add new "Case", <br> where user has to fill form of the Case': 'Wenn Sie auf "+" klicken, können Sie einen neuen Antrag erstellen, <br> hier füllen Sie den Antrag aus.',
    'Fill Data to create Case': 'Füllen Sie die Daten ein, um den Antrag zu erstellen.',
    'Get Started': 'Legen Sie los!',
    'Income statement-sum debit / credit': 'Erfolgsrechnung-Summe Soll/Haben',
    'Search & Reports': 'Suchen und Berichte',
    'Report': 'Bericht',
    'Initials of the godchild (e.g. A.Z.)': 'Initialen des Patenkindes (z.B. A.Z.)',
    'Are you sure want to delete this comment?': 'Sind Sie sicher, dass Sie diesen Kommentar löschen wollen?',
    'Next': 'Nächste',
    'Open cases': 'Offene anträge',
    'Archive': 'Archiv',
    'You are logged in with the auto generated credentials.': 'Sie sind mit den automatisch erstellen Zugangsdaten eingeloggt. ',
    'Click Here': 'Klicken Sie hier',
    'to Change password.': 'Passwort ändern',
    'No Notification found.': 'Keine Benachrichtigung gefunden.',
    'Open Cases': 'offene Anträge',
    'Privacy Policy': 'Datenschutzrichtlinie',
    'Social Unit Registration is confirmed !': 'Fachstellen Registration wurde bestätigt!',
    'Header': 'Header',
    'Footer': 'Fußzeile',
    'Left': 'Links',
    'Are you sure want to reset freezed booking list?': 'Möchten Sie die Liste der eingefrorenen Buchungen wirklich zurücksetzen?',
    'Are you sure want to freezed booking list?': 'Möchten Sie die Buchungsliste wirklich einfrieren?',
    'needy': 'bedürftig',
    'special': 'behindert',
    'yes': 'Ja',
    'no': 'Nein',
    'Reject case description': 'Fall ablehnen Beschreibung',
    'Case re-open successfully!': 'WIEDERERÖFFNEN war erfolgreich!',
    'Currently no any transactions are added in list.': 'Derzeit sind keine Transaktionen in der Liste hinzugefügt.',
    'club contacts': 'Kontakte Clubs',
    'fachstellen contacts': 'Fachstelle Kontakte',
    'organization contacts': 'Organisationen Kontakte',
    'stage_1': 'Steht aus',
    'stage_2': 'Zur Abstimmung geschickt',
    'stage_3': 'Bestätigung ausstehend',
    'donated': 'Bestätigt',
    'rejected': 'Abgelehnt',
    'Manage Admins': 'Administratoren verwalten',
    'Admins': 'Administratoren',
    'Create Admins': 'Erstellen Administratoren',
    'The password field must be at least 8 characters.': 'Das Passwortfeld muss aus mindestens 8 Zeichen bestehen.',
    'Erstaufnahme': 'Erstaufnahme',
    'Confirmed Amount': 'Bestätigter Betrag',
    'payment_date': 'Zahlungsdatum',
    'payment_status': 'Zahlungsstatus',
    'paid': 'Bezahlt',
    'unpaid': 'Unbezahlt',
    'paidon': 'Bezahlt am',
    'Paid Date Case': 'Zahlungsdatum erfolgreich hinzugefügt',
    'pdf download': 'PDF Herunterladen',
    'export excel' : 'Excel exportieren',
    'Past Cases': 'FRÜHERE ANTRÄGE',
    'Remarks of the Office' : 'Bemerkungen der KiPaKi Geschäftsstelle',
    'select file' : 'DATEI HOCHLADEN',
    'view file' : 'Datei ansehen',
    'delete file' : 'Datei löschen',
    'Fields with a ! Can be viewed by the board members. Please anonymise text for data protection reasons.':'Felder mit einem ! können durch die Vorstände eingesehen werden. Bitte Text aus Datenschutzgründen anonymisieren.',
    'What is requested (e.g. membership fee FC Musterdorf)' : 'Was wird beantragt (z.B. Mitgliederbeitrag FC Musterdorf)',
    'Anonymised description of the application (application details, deductible, benefit for the child)':'Anonymisierte Beschreibung des Antrages  (Antragdetails, Selbstbeteiligung, Nutzen für das Kind)',
    'saldo': 'Saldo',
    'Chat with Social unit' : 'Chatten Sie mit Fachagenturen',
    'Chat with Orgaisation Admin' : 'Chatten Sie mit Organisationen',
}


// WEBPACK FOOTER //
// ./src/assets/lan/de.js